"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LNBContainer = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var constants_1 = require("@/constants");
exports.LNBContainer = styled_1.default.nav(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-width: 20rem;\n  height: calc(100vh - ", ");\n  overflow: scroll;\n  box-shadow: inset -1px 0px ", ";\n"], ["\n  min-width: 20rem;\n  height: calc(100vh - ", ");\n  overflow: scroll;\n  box-shadow: inset -1px 0px ", ";\n"])), constants_1.HEADER_HEIGHT, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray100;
});
var templateObject_1;
